export const AUTHZ_AUTHN_ERROR = 'AuthN/AuthZ';
export const HOME_PATH = '/home/';
